import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';

import { Button } from 'components/ui/button';
import { confirmable } from 'react-confirm';

class ConfirmDialog extends React.Component {
  static propTypes = {
    cancel: PropTypes.func,
    message: PropTypes.node.isRequired,
    options: PropTypes.shape({
      cancelButtonLabel: PropTypes.string,
      buttonLabel: PropTypes.string.isRequired,
      buttonStyle: PropTypes.string.isRequired,
      title: PropTypes.string,
    }).isRequired,
    proceed: PropTypes.func,
    show: PropTypes.bool
  }

  render() {
    const { message, options, show, cancel, proceed } = this.props;

    return (
      <Modal centered show={show} onHide={() => cancel()}>
        {options.title && (
          <Modal.Header closeButton>
            <Modal.Title as="h5">{options.title}</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button variant="ghost" onClick={() => cancel()}>
            {options.cancelButtonLabel || 'Cancel'}
          </Button>
          <Button variant={options.buttonStyle === 'danger' ? 'destructive' : 'primary'} onClick={() => proceed()}>
            {options.buttonLabel || 'Yes'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default confirmable(ConfirmDialog);
